export function getLangDate() {
  var dateObj = new Date() // 表示当前系统时间的Date对象
  var year = dateObj.getFullYear() // 当前系统时间的完整年份值
  var month = dateObj.getMonth() + 1 // 当前系统时间的月份值
  var date = dateObj.getDate() // 当前系统时间的月份中的日
  var day = dateObj.getDay() // 当前系统时间中的星期值
  var weeks = [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六'
  ]
  var week = weeks[day] // 根据星期值，从数组中获取对应的星期字符串
  var hour = dateObj.getHours() // 当前系统时间的小时值
  var minute = dateObj.getMinutes() // 当前系统时间的分钟值
  var second = dateObj.getSeconds() // 当前系统时间的秒钟值
  // 如果月、日、小时、分、秒的值小于10，在前面补0
  if (month < 10) {
    month = '0' + month
  }
  if (date < 10) {
    date = '0' + date
  }
  if (hour < 10) {
    hour = '0' + hour
  }
  if (minute < 10) {
    minute = '0' + minute
  }
  if (second < 10) {
    second = '0' + second
  }
  var newDate =
    year +
    '年' +
    month +
    '月' +
    date +
    '日 ' +
    '<br>' +
    week +
    ' ' +
    hour +
    ':' +
    minute +
    ':' +
    second

  return newDate
}

export function scrollTo(pos = 0) {
  document.body.scrollTop = document.documentElement.scrollTop = pos
}



// WEBPACK FOOTER //
// ./src/functions/common.js